import { PropertyOnboardingNotificationAction } from 'src/pages/properties/types';
import { call } from '../@';

const propertyOnboardingNotification = (propertyId: string, action: PropertyOnboardingNotificationAction) =>
	call('propertyOnboarding-notification', { propertyId, action });

export default propertyOnboardingNotification;
